import { render } from "./AllSpeedrunnerLogoHeli.vue?vue&type=template&id=b7d3fa08"
const script = {}

import exportComponent from "/builds/skilltech-ph/app/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__